import { Badge } from "@/components/ui/badge";

export const RoomStatus = ({ status }: { status: string }) => {
  const variants: Record<
    string,
    "default" | "secondary" | "destructive" | "outline"
  > = {
    waiting: "default",
    playing: "secondary",
    finished: "outline",
  };

  const labels: Record<string, string> = {
    waiting: "대기중",
    playing: "게임중",
    finished: "완료됨",
  };

  return (
    <Badge variant={variants[status] || "outline"}>
      {labels[status] || status}
    </Badge>
  );
};
